import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _h, _strong, _br, _strong2, _Button, _Button2;
import React, { useRef } from 'react';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import parse from 'html-react-parser';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function EditTranslateModal(props) {
  var clearErrorMessage = props.clearErrorMessage,
    errorMessage = props.errorMessage,
    onClose = props.onClose,
    onPreviewChange = props.onPreviewChange,
    onRaiseRequestChange = props.onRaiseRequestChange,
    onResetHandleChange = props.onResetHandleChange,
    onSaveHandleChange = props.onSaveHandleChange,
    open = props.open,
    showPleaseWaitLabel = props.showPleaseWaitLabel,
    showPleaseWaitLabelOnSave = props.showPleaseWaitLabelOnSave,
    showRequestButton = props.showRequestButton,
    translationKey = props.translationKey,
    translationValue = props.translationValue,
    value = props.value;
  var ref = useRef(null);
  return /*#__PURE__*/_jsx(Dialog, {
    PaperProps: {
      onClick: function onClick(e) {
        return e.stopPropagation();
      }
    },
    "data-html2canvas-ignore": "true",
    onClose: onClose,
    open: open,
    children: /*#__PURE__*/_jsxs(Root, {
      children: [_h || (_h = /*#__PURE__*/_jsx("h2", {
        children: "Edit translation"
      })), /*#__PURE__*/_jsxs("p", {
        children: [_strong || (_strong = /*#__PURE__*/_jsx("strong", {
          children: "Key"
        })), ": ", translationKey, _br || (_br = /*#__PURE__*/_jsx("br", {})), _strong2 || (_strong2 = /*#__PURE__*/_jsx("strong", {
          children: "Value"
        })), ": ", translationValue]
      }), /*#__PURE__*/_jsx("textarea", {
        defaultValue: value,
        onChange: clearErrorMessage,
        ref: ref
      }), /*#__PURE__*/_jsxs(Stack, {
        direction: "row",
        spacing: 2,
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: function onClick() {
            return onPreviewChange(ref && ref.current ? ref.current.value : '');
          },
          variant: "outlined",
          children: "Preview"
        }), showPleaseWaitLabelOnSave ? _Button || (_Button = /*#__PURE__*/_jsx(Button, {
          disabled: true,
          children: "Please wait"
        })) : /*#__PURE__*/_jsx(Button, {
          onClick: function onClick() {
            return onSaveHandleChange(ref && ref.current ? ref.current.value : '', translationKey);
          },
          variant: "outlined",
          children: "Save"
        }), showRequestButton && /*#__PURE__*/_jsx(_Fragment, {
          children: showPleaseWaitLabel ? _Button2 || (_Button2 = /*#__PURE__*/_jsx(Button, {
            disabled: true,
            children: "Please wait"
          })) : /*#__PURE__*/_jsx(Button, {
            onClick: function onClick() {
              return onRaiseRequestChange();
            },
            variant: "outlined",
            children: "Raise a request"
          })
        }), /*#__PURE__*/_jsx(Button, {
          color: "error",
          onClick: function onClick() {
            return onResetHandleChange();
          },
          variant: "outlined",
          children: "Reset"
        })]
      }), errorMessage && /*#__PURE__*/_jsx(Typography, {
        color: "error",
        marginTop: 2,
        variant: "body1",
        children: parse(errorMessage)
      })]
    })
  });
}
var Root = styled('div')(function () {
  return _defineProperty(_defineProperty(_defineProperty({}, ">h2", {
    margin: 0
  }), ">textarea", {
    height: '100px',
    marginBottom: '10px',
    padding: '10px',
    width: '500px'
  }), "padding", '15px');
});